import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import widgetEventsUtility from "utilities/global/sparta-widget-events-utility/3.0.1/js/sparta-widget-events-utility";
import spartaBootstrapUtility from "utilities/global/sparta-bootstrap-utility/5.4.3/js/sparta-bootstrap-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";




const defaults = {};





const EVENTS = {
  GLOBAL_READY: spartaBootstrapUtility.EVENTS.SPARTA_GLOBAL_READY,
  WIDGET_READY: 'SPARTA_WIDGET_READY.spartaWidgetUtility',
  WIDGET_ID: 'SPARTA_WIDGET_ID.spartaWidgetUtility',
};





class Widget {




  constructor(options = {}) {

    this.settings = Object.assign({}, defaults, options);


    this.name = null;
    this.version = null;
    this.containers = null;
    this.fadeInOnReady = true;
    this.widgetLoaded = false;


    this.spartaStore = spartaStoreUtility;
    this.spartaEvents = spartaEventsUtility;
    this.widgetEvents = widgetEventsUtility;

    const { id, loader_version, oldVersion } = this.settings;
    const widgetInfo = Object.assign(this.info, { id, loader_version, oldVersion });
    this.widgetEvents.setWidgetInfo(widgetInfo);


    this.bindSuperClassEvents();
  }


  get container() {
    return this.containers[0] || null;
  }






  get EVENTS() {
    return EVENTS;
  }





  bindSuperClassEvents() {
    this.globalReadySubToken = this.spartaEvents.sub(this.EVENTS.GLOBAL_READY, this.emitWidgetReady.bind(this));
  }






  emitWidgetReady() {
    if (this.widgetLoaded) return;


    this.spartaEvents.unsubWidgetByToken(this.globalReadySubToken);


    const { name, version } = spartaStoreUtility.getData('applicationContext');    


    const preContainers = spartaStoreUtility.getData('applicationContainer');
    const containers = Array.isArray(preContainers) ? preContainers : [preContainers];


    this.name = name;
    this.version = version;
    this.containers = containers;
    this.id = this.settings.id;


    this.widgetEvents.pub(this.EVENTS.WIDGET_READY, { widget: { name: this.name, version: this.version, id: this.id  } });


    this.widgetReady();


    if (!this.widgetLoaded) {
      this.widgetLoaded = true;


      this.widgetEvents.sub("refreshWidget", function(event) {
        if (event.detail.name === this.name && event.detail.version === this.version) {
          this.refreshWidget(event);
        }
      }.bind(this));
    }
  }





  widgetReady() {

    if (this.fadeInOnReady) {
      this.containers.forEach((currentContainer) => {
        const loadingElement = currentContainer.querySelector('.sparta-widget');

        loadingElement.classList.add('sparta-animate-fade-in');
        currentContainer.classList.remove('sparta-widget-loading');
      })
    }


    this.removeWidgetParentSpinner();
  }






  refreshWidget(event) {

  };





  removeWidgetParentSpinner() {
    this.containers.forEach((currentContainer) => {
      currentContainer.style.visibility = 'visible';
      currentContainer.classList.remove('sparta-widget-loading');
      currentContainer.parentNode.classList.remove('sparta-widget-loading');
    });
  }
}

export default Widget;
